import { regionOptions, countryOptions, usaStates } from "../../util/countryOptions";
import { getSubcategories } from "../../util/misc";

export const getLocationFilters = (searchParsed) => {
    const { pub_region, pub_country } = searchParsed || {};
    const regionFilter = {
        key: "region",
        scope: "public",
        schemaType: "multi-enum",
        enumOptions: regionOptions.map(r => {
            return {
                label: r.label,
                option: r.value,
                suboptions: countryOptions
                    .filter(c => c.region == r.value)
                    .map(r => {
                        return {
                            label: r.label,
                            option: r.value,
                        };
                    }),
            };
        }),
        filterConfig: {
            indexForSearch: true,
            label: "Region",
            filterType: "SelectMultipleFilter",
            searchMode: "has_any",
            group: "primary",
            nestedQueryParams: ["pub_region", "pub_country"],
        },
        categoryConfig: {
            limitToCategoryIds: false,
        },
        isNestedEnum: true,
    };

    const regions = getSubcategories(pub_region);
    const regionExists = regions.length > 0;
    const countries = regionExists
        ? countryOptions
            .filter(c => regions.includes(c.region))
            .map(r => {
                return {
                    label: r.label,
                    option: r.value,
                };
            })
            .sort((a, b) => {
                return a.label.localeCompare(b.label);
            })
        : [];

    const countryFilterMaybe = regionExists ? {
        key: "country",
        scope: "public",
        schemaType: "multi-enum",
        enumOptions: countries,
        filterConfig: {
            indexForSearch: true,
            label: "Country",
            filterType: "SelectMultipleFilter",
            searchMode: "has_any",
            group: "primary",
        },
        categoryConfig: {
            limitToCategoryIds: false,
        },
        isNestedEnum: false,
    } : null;

    const filterCountries = getSubcategories(pub_country);
    const usaExists = filterCountries.includes("unitedStates");
    const states = usaExists
        ? usaStates.map(r => {
            return {
                label: r.label,
                option: r.value,
            };
        }) : [];

    const stateFilterMaybe = usaExists ? {
        key: "state",
        scope: "public",
        schemaType: "multi-enum",
        enumOptions: states,
        filterConfig: {
            indexForSearch: true,
            label: "State",
            filterType: "SelectMultipleFilter",
            searchMode: "has_any",
            group: "primary",
        },
        categoryConfig: {
            limitToCategoryIds: false,
        },
        isNestedEnum: false,
    } : null;

    return [
        regionFilter,
        countryFilterMaybe,
        stateFilterMaybe,
    ].filter(v => v);
};

// export const getLocationFilters = () => {
//     const regionFilter = {
//         key: "region",
//         scope: "public",
//         schemaType: "enum",
//         enumOptions: regionOptions.map(r => {
//             return {
//                 label: r.label,
//                 option: r.value,
//                 suboptions: countryOptions
//                     .filter(c => c.region == r.value)
//                     .map(r => {
//                         return {
//                             label: r.label,
//                             option: r.value,
//                         };
//                     }),
//             };
//         }),
//         filterConfig: {
//             indexForSearch: true,
//             label: "Region",
//             filterType: "SelectSingleFilter",
//             searchMode: "has_any",
//             group: "primary",
//             nestedQueryParams: ["pub_region", "pub_country"],
//         },
//         categoryConfig: {
//             limitToCategoryIds: false,
//         },
//         isNestedEnum: true,
//     };

//     return [
//         regionFilter,
//     ].filter(v => v);
// };